import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { noWhitespaceValidator } from '../../../../shared/src/lib/service/helper.service';

@Component({
  selector: 'piqet-angular-add-country',
  templateUrl: './add-country.component.html',
  styleUrls: ['./add-country.component.scss'],
})
export class AddCountryComponent {
  modalLabel: any;
  adminCountryData: any;
  countryAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  regionList: any;
  regionData: any;
  regionItems: any;
  selectRegion: any;
  isDisabledDropDown!: boolean;
  @Output() saveCountryEvent = new EventEmitter<any>();

  constructor(private modal: CustomModalService, private formBuilder: FormBuilder) {
    this.adminCountryData = this.modal?.modalService?.config?.initialState?.['countryData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review Country' ? true : false;
    const newRegionlist = this.adminCountryData.regionItems;
    this.regionList = newRegionlist;
    this.getRegionData();
  }

  ngOnInit(): void {
    this.countryAddEditForm = this.formBuilder.group({
      region: [null, Validators.required],
      country: [this.adminCountryData.name || '', [Validators.required, noWhitespaceValidator]],
    });
    this.setFormData();
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.adminCountryData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.countryAddEditForm.patchValue({ region: this.selectRegion });
  }

  onSave() {
    this.submitted = true;
    if (!this.countryAddEditForm.controls['country'].value) {
      return;
    }
    if (this.countryAddEditForm.status == 'VALID') {
      const countryPayload = {
        id: this.adminCountryData.id || 0,
        name: this.countryAddEditForm.controls['country'].value.trimStart(),
        regionId:
          this.countryAddEditForm.controls['region'].value.id ||
          this.countryAddEditForm.controls['region'].value,
      };
      this.saveCountryEvent.emit(countryPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }
}
